export const sxStyles = {
  loaderWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '2rem',
  },
  subtitle: {
    marginBottom: '2rem',
  },
  summaryItemWrap: {
    display: 'flex',
    marginBottom: '0.5rem',

    '& > h5:first-of-type': {
      minWidth: '130px',
      marginRight: '1rem',
    },
  },
};
